export const goTo = (navigate, url) => {
    navigate('/' + url);
}

export const removeEmptyProperties = (myObj) => {
    var newObject = {};
    if (!!myObj) {
        Object.keys(myObj).forEach((key) => {
            if (myObj[key] !== '')
                newObject[key] = myObj[key];
        });
    }
    return newObject;
}

export const convertArrayToString = (myObj) => {
    var newObject = {};
    if (!!myObj) {
        Object.keys(myObj).forEach((key) => {
            if (Array.isArray(myObj[key]))
                newObject[key] = myObj[key].join(',');
            else
                newObject[key] = myObj[key];
        });
    }
    return newObject;
}

export const compareStrings = (a, b) => {
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
}

export const validDate = (dateString) => {
    try {
        new Date(dateString);
        return true;
    } catch (error) {
        return false;
    }
};

export const dateFromString = (dateString) => {
    try {
        if (dateString instanceof Date) {
            return dateString;
        }
        const dateSplitted = dateString.split('-');
        return new Date(dateSplitted[0], dateSplitted[1] - 1, dateSplitted[2]);
    } catch (error) {
        return new Date();
    }
}

export const addMonthsToDate = function (date, numberOfMonths) {
    const tempDate = new Date(date.getTime());
    return new Date(tempDate.setMonth(tempDate.getMonth() + numberOfMonths));
}

export const getDatesPerMonth = function (startDate, endDate) {
    const columns = [];
    const finalYear = endDate.getFullYear();
    const finalMonth = endDate.getMonth() + 1;
    let year = startDate.getFullYear();
    let month = startDate.getMonth() + 1;

    while (year < finalYear || (year === finalYear && month <= finalMonth)) {
        let formattedMonth = month;
        if (formattedMonth < 10)
            formattedMonth = `0${month}`;

        columns.push(`${formattedMonth}/${year}`);
        month++;
        if (month === 13) {
            month = 1;
            year++;
        }
    }
    return columns;
}

export const getDateMonthAndYear = function (date) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;

    let formattedMonth = month;
    if (formattedMonth < 10)
        formattedMonth = `0${month}`;

    return `${formattedMonth}/${year}`;
}

export function convertToCSV(data, columnsToMap) {
  const csvHeaders = columnsToMap.map(col => col.title).join(',');

    const csvRows = data.map(row =>
        columnsToMap.map(header => {
            let value = row[header.field];
            if (typeof value === 'string') return `"${value.replace(/"/g, '""')}"`;
            return value;
        }).join(',')
    );

  return [csvHeaders, ...csvRows].join('\n');
}

export function downloadCSV(data,columnsToMap, fileName) {
  const csvString = convertToCSV(data,columnsToMap);
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function getPasswordErrors (password) {
  const errors = [];
  const minLength = 8;
  const passwordRules = [
    { rule: (p) => p.length >= minLength, message: `Mínimo ${minLength} caracteres` },
    { rule: (p) => /[a-z]/.test(p), message: 'Pelo menos uma letra minúscula' },
    { rule: (p) => /[A-Z]/.test(p), message: 'Pelo menos uma letra maiúscula' },
    { rule: (p) => /[0-9]/.test(p), message: 'Pelo menos um número' },
    { rule: (p) => /[!@#$%^&*]/.test(p), message: 'Pelo menos um caractere especial (!@#$%^&*)' },
  ];

  if (!password) {
    return passwordRules.map(rule => rule.message);
  }

  passwordRules.forEach(ruleObj => {
    if (!ruleObj.rule(password)) {
      errors.push(ruleObj.message);
    }
  });

  return errors;
}
export function getFirstDayOfMonth(year, month) {
    return `${year}-${String(month + 1).padStart(2, '0')}-01`;
};

export function getLastDayOfMonth(year, month) {
    const lastDay = new Date(year, month + 1, 0).getDate();
    return `${year}-${String(month + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
};